/* eslint-env browser */
import { merge } from 'lodash';

const Auth0Lock = window.Auth0Lock;
const auth0IconUrl = 'https://cdn.auth0.com/styleguide/components/1.0.8/media/logos/img/badge.png';

const AUTH0_CLIENT_ID = window.APP_CONFIG.AUTH0_CLIENT_ID;
const AUTH0_DOMAIN = window.APP_CONFIG.AUTH0_DOMAIN;
const AUTH0_CALLBACK_URL = window.APP_CONFIG.AUTH0_CALLBACK_URL;

/**
 * Main Lock
 */
const main = {
  options: {
    auth: { redirectUrl: AUTH0_CALLBACK_URL },
    theme: {
      logo: auth0IconUrl
    },
    rememberLastLogin: true,
    integratedWindowsLogin: false,
    socialButtonStyle: 'big',
    languageDictionary: {
      // eslint-disable-next-line max-len
      signUpTerms: 'By signing up, you agree to our <a href="/terms" target="_new">terms of service</a> and <a href="/privacy" target="_new">privacy policy</a>',
      emailInputPlaceholder: 'Work email',
      passwordInputPlaceholder: 'Your password'
    }
  }
};
main.lock = new Auth0Lock(AUTH0_CLIENT_ID, AUTH0_DOMAIN, main.options);
main.show = () => {
  main.lock.show({ initialScreen: 'login' });
};
main.signup = options => {
  const opts = merge({}, main.options);

  if (options) {
    merge(opts, options);
  }
  main.lock.show({ initialScreen: 'signUp' });
};

export default main;



// WEBPACK FOOTER //
// ./src/modules/locks/locks.js